// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* region BLOCK */
:where(.vuetify-styles) .v-text-field input {
  color: inherit;
  flex: 1;
  transition: 0.15s opacity cubic-bezier(0.4, 0, 0.2, 1);
  min-width: 0;
}
:where(.vuetify-styles) .v-text-field input:focus, :where(.vuetify-styles) .v-text-field input:active {
  outline: none;
}
:where(.vuetify-styles) .v-text-field input:invalid {
  box-shadow: none;
}
:where(.vuetify-styles) .v-text-field .v-field {
  cursor: text;
}
:where(.vuetify-styles) .v-text-field--prefixed.v-text-field .v-field:not(.v-field--reverse) .v-field__input {
  --v-field-padding-start: 6px;
}

:where(.vuetify-styles) .v-text-field--suffixed.v-text-field .v-field:not(.v-field--reverse) .v-field__input {
  --v-field-padding-end: 0;
}

:where(.vuetify-styles) .v-text-field--prefixed.v-text-field .v-field.v-field--reverse .v-field__input {
  --v-field-padding-end: 6px;
}

:where(.vuetify-styles) .v-text-field--suffixed.v-text-field .v-field.v-field--reverse .v-field__input {
  --v-field-padding-start: 0;
}

:where(.vuetify-styles) .v-text-field .v-field:not(.v-field--no-label, .v-field--active) input::placeholder {
  opacity: 0;
}
:where(.vuetify-styles) .v-text-field .v-input__details {
  padding-inline: 16px;
}
:where(.vuetify-styles) .v-input--plain-underlined.v-text-field .v-input__details {
  padding-inline: 0;
}

:where(.vuetify-styles) .v-text-field .v-field--single-line input {
  transition: none;
}

/* endregion */
/* region ELEMENTS */
:where(.vuetify-styles) .v-text-field__prefix, :where(.vuetify-styles) .v-text-field__suffix {
  align-items: center;
  color: rgba(var(--v-theme-on-surface), var(--v-medium-emphasis-opacity));
  cursor: default;
  display: flex;
  opacity: 0;
  transition: inherit;
  white-space: nowrap;
  min-height: max(var(--v-input-control-height, 56px), 1.5rem + var(--v-field-input-padding-top) + var(--v-field-input-padding-bottom));
  padding-top: calc(var(--v-field-padding-top, 4px) + var(--v-input-padding-top, 0));
  padding-bottom: var(--v-field-padding-bottom, 6px);
}
:where(.vuetify-styles) .v-field--active .v-text-field__prefix, :where(.vuetify-styles) .v-field--active .v-text-field__suffix {
  opacity: 1;
}
:where(.vuetify-styles) .v-field--disabled .v-text-field__prefix, :where(.vuetify-styles) .v-field--disabled .v-text-field__suffix {
  color: rgba(var(--v-theme-on-surface), var(--v-disabled-opacity));
}
:where(.vuetify-styles) .v-field:not(.v-field--reverse) .v-text-field__prefix {
  padding-inline-start: var(--v-field-padding-start);
}

:where(.vuetify-styles) .v-field.v-field--reverse .v-text-field__prefix {
  padding-inline-end: var(--v-field-padding-end);
}

:where(.vuetify-styles) .v-field:not(.v-field--reverse) .v-text-field__suffix {
  padding-inline-end: var(--v-field-padding-end);
}

:where(.vuetify-styles) .v-field.v-field--reverse .v-text-field__suffix {
  padding-inline-start: var(--v-field-padding-start);
}

/* endregion */`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VTextField/VTextField.css"],"names":[],"mappings":"AAAA,iBAAiB;AACjB;EACE,cAAc;EACd,OAAO;EACP,sDAAsD;EACtD,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;AACA;EACE,oBAAoB;AACtB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,cAAc;AACd,oBAAoB;AACpB;EACE,mBAAmB;EACnB,wEAAwE;EACxE,eAAe;EACf,aAAa;EACb,UAAU;EACV,mBAAmB;EACnB,mBAAmB;EACnB,qIAAqI;EACrI,kFAAkF;EAClF,kDAAkD;AACpD;AACA;EACE,UAAU;AACZ;AACA;EACE,iEAAiE;AACnE;AACA;EACE,kDAAkD;AACpD;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,kDAAkD;AACpD;;AAEA,cAAc","sourcesContent":["/* region BLOCK */\n.v-text-field input {\n  color: inherit;\n  flex: 1;\n  transition: 0.15s opacity cubic-bezier(0.4, 0, 0.2, 1);\n  min-width: 0;\n}\n.v-text-field input:focus, .v-text-field input:active {\n  outline: none;\n}\n.v-text-field input:invalid {\n  box-shadow: none;\n}\n.v-text-field .v-field {\n  cursor: text;\n}\n.v-text-field--prefixed.v-text-field .v-field:not(.v-field--reverse) .v-field__input {\n  --v-field-padding-start: 6px;\n}\n\n.v-text-field--suffixed.v-text-field .v-field:not(.v-field--reverse) .v-field__input {\n  --v-field-padding-end: 0;\n}\n\n.v-text-field--prefixed.v-text-field .v-field.v-field--reverse .v-field__input {\n  --v-field-padding-end: 6px;\n}\n\n.v-text-field--suffixed.v-text-field .v-field.v-field--reverse .v-field__input {\n  --v-field-padding-start: 0;\n}\n\n.v-text-field .v-field:not(.v-field--no-label, .v-field--active) input::placeholder {\n  opacity: 0;\n}\n.v-text-field .v-input__details {\n  padding-inline: 16px;\n}\n.v-input--plain-underlined.v-text-field .v-input__details {\n  padding-inline: 0;\n}\n\n.v-text-field .v-field--single-line input {\n  transition: none;\n}\n\n/* endregion */\n/* region ELEMENTS */\n.v-text-field__prefix, .v-text-field__suffix {\n  align-items: center;\n  color: rgba(var(--v-theme-on-surface), var(--v-medium-emphasis-opacity));\n  cursor: default;\n  display: flex;\n  opacity: 0;\n  transition: inherit;\n  white-space: nowrap;\n  min-height: max(var(--v-input-control-height, 56px), 1.5rem + var(--v-field-input-padding-top) + var(--v-field-input-padding-bottom));\n  padding-top: calc(var(--v-field-padding-top, 4px) + var(--v-input-padding-top, 0));\n  padding-bottom: var(--v-field-padding-bottom, 6px);\n}\n.v-field--active .v-text-field__prefix, .v-field--active .v-text-field__suffix {\n  opacity: 1;\n}\n.v-field--disabled .v-text-field__prefix, .v-field--disabled .v-text-field__suffix {\n  color: rgba(var(--v-theme-on-surface), var(--v-disabled-opacity));\n}\n.v-field:not(.v-field--reverse) .v-text-field__prefix {\n  padding-inline-start: var(--v-field-padding-start);\n}\n\n.v-field.v-field--reverse .v-text-field__prefix {\n  padding-inline-end: var(--v-field-padding-end);\n}\n\n.v-field:not(.v-field--reverse) .v-text-field__suffix {\n  padding-inline-end: var(--v-field-padding-end);\n}\n\n.v-field.v-field--reverse .v-text-field__suffix {\n  padding-inline-start: var(--v-field-padding-start);\n}\n\n/* endregion */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
